import React from "react";
import { Helmet } from "react-helmet-async";
import Hero from "../components/page-components/case-study/Hero";
import CaseStudies from "../components/page-components/case-study/CaseStudyCard";

function CaseStudy() {
  return (
    <>
      <Helmet>
        <title>
          Case Studies | Web Development, SaaS & Digital Transformation Projects
        </title>

        <meta
          name="description"
          content="Explore Web X Secure case studies including website development, SaaS platforms, inventory management systems, CMS solutions, web applications and digital transformation projects."
        />

        <meta
          name="keywords"
          content="Web Development Case Studies, SaaS Case Studies, CMS Development, Inventory Management System, Web Application Projects, Digital Transformation Projects"
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://webxsecure.in/case-study" />

        <meta
          property="og:title"
          content="Web X Secure Case Studies | Web Development & SaaS Projects"
        />

        <meta
          property="og:description"
          content="View real-world web development, SaaS, CMS, inventory management and digital transformation projects by Web X Secure."
        />

        <meta property="og:url" content="https://webxsecure.in/case-study" />

        <meta property="og:image" content="https://webxsecure.in/logo.png" />

        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content="Web X Secure Case Studies" />

        <meta
          name="twitter:description"
          content="Explore real-world web development, SaaS, CMS and business automation projects."
        />

        <meta name="twitter:image" content="https://webxsecure.in/logo.png" />

        {/* Collection Page Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Web X Secure Case Studies",
            url: "https://webxsecure.in/case-study",
            description:
              "Case studies of website development, SaaS platforms, CMS systems, inventory management systems, web applications and digital transformation projects.",
          })}
        </script>

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Case Studies",
                item: "https://webxsecure.in/case-study",
              },
            ],
          })}
        </script>
      </Helmet>

      <Hero />
      <CaseStudies />
    </>
  );
}

export default CaseStudy;
